import { VoiceNotice } from './useVoiceTurn';

/** Why the words did not get through, as the user is told. */
export const kVoiceNoticeText: Record<Exclude<VoiceNotice, null>, string> = {
  unheard: '没听清，再说一次',
  microphone: '需要麦克风权限，也可以打字',
  credits: 'AI 积分不足，语音暂时用不了，可以打字',
  busy: '上一段语音还在识别，稍等再说',
  too_long: '一次说得太长了，分成几句说',
  not_enabled: '语音输入未开通，可以打字',
  failed: '语音没识别出来，再说一次或打字',
};
